import { Fragment, useEffect } from 'react'
import { useTranslation } from 'next-i18next'

import { InputDashboard } from '~/components/InputDashboard'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'

import {
  selectErrors,
  selectFields,
  resetPasswordFieldActionCreator,
  setFieldValueActionCreator,
} from '../redux/settings.slice'

export function ChangePasswordTab(): React.ReactElement {
  const { t } = useTranslation('fields')

  const dispatch = useAppDispatch()

  const fields = useAppSelector(selectFields)
  const errors = useAppSelector(selectErrors)

  useEffect(() => {
    dispatch(resetPasswordFieldActionCreator())
  }, [dispatch])

  return (
    <Fragment>
      <InputDashboard
        autoComplete="off"
        errorMessage={errors?.currPassword}
        label={t('currPassword')}
        name="currPassword"
        onChange={(currPassword) =>
          dispatch(setFieldValueActionCreator({ fieldName: 'currPassword', value: currPassword }))
        }
        type="password"
        value={fields.currPassword}
      />
      <InputDashboard
        autoComplete="off"
        errorMessage={errors?.newPassword}
        label={t('newPassword')}
        name="newPassword"
        onChange={(newPassword) =>
          dispatch(setFieldValueActionCreator({ fieldName: 'newPassword', value: newPassword }))
        }
        type="password"
        value={fields.newPassword}
      />
      <InputDashboard
        autoComplete="off"
        errorMessage={errors?.newPasswordConfirm}
        label={t('newPasswordConfirm')}
        name="newPasswordConfirm"
        onChange={(newPasswordConfirm) =>
          dispatch(setFieldValueActionCreator({ fieldName: 'newPasswordConfirm', value: newPasswordConfirm }))
        }
        type="password"
        value={fields.newPasswordConfirm}
      />
    </Fragment>
  )
}
